
import "./tournament-round-line-item.scss";
import {
  CENTER,
  defaultGapping,
  defaultLayouts,
  defaultPadding,
  golfstatusColors,
  GSButton,
  GSDivider,
  GSInfoGroup,
  GSItemList, START,
  useMediaQuery,
} from "golfstatus_react_components";
import { getDateTimeOn } from "../../../helpers/Dates";
import { useNavigate } from "react-router-dom";
import { faClone, faPen } from "@fortawesome/free-solid-svg-icons";
import { getStateColor } from "../../../helpers/Converters";
import { useRoundActionHooks, getRoundName } from "../../../hooks/round/roundHooks";

const TournamentRoundLineItem = (props) => {
  const navigate = useNavigate();

  const {
    round,
    hideCopy,
    hideActions,
    editRound,
    isListItem,
    subRoundLabel,
    linkedRounds,
  } = props;

  const {priorityActions} = useRoundActionHooks(round)

  const {isPhone} = useMediaQuery()


  const copyRound = (e) => {
    navigate(`${round.id}/copy`);
    e?.stopPropagation?.();
  };

  const onEditClicked = (e) => {
    editRound?.(round);
    e?.stopPropagation?.();
  };

  const RoundInfo = {
    fit: "stretch",
    sections: [
      {
        sectionItems: [
          {
            type: "secondary no-wrap",
            value: `${round?.tournamentFormats
              ?.map?.((f) => f.name)
              ?.join?.(",")}`,
          },
        ],
      },
      {
        sectionItems: [
          {
            type: "secondary no-wrap",
            value: `${getDateTimeOn(round?.startAt)}` ?? `TBD`,
          },
          {
            type: "secondary no-wrap capitalize",
            value: round?.startType?.replaceAll?.("_", " ") ?? `Invalid Facility`,
          },
        ],
      },
      {
        sectionItems: [
          {
            type: "secondary no-wrap",
            value: round?.facility?.name ?? `Invalid Facility`,
          },
        ],
      },
    ],
  };

  //the list item presentation shows the round name in its own header, the hero
  //presentation keeps it as the first piece of round info. a round named for its
  //own label or for the sub round it is carries its number underneath, since
  //neither of those says what the round is numbered.
  if (!isListItem) {
    const roundLabel = `Round ${getRoundName(round, linkedRounds)}`;
    const numberLabel = `Round ${round?.number}`;

    RoundInfo.sections.unshift({
      sectionItems: [
        {
          type: "primary no-wrap",
          value: roundLabel,
        },
        ...(roundLabel !== numberLabel
          ? [{ type: "tertiary no-wrap", value: numberLabel }]
          : []),
      ],
    });
  }

  //each course carries the teams assigned to the holes it plays
  const getHoles = (c) => {
    return (
      <div
        style={{
          ...defaultLayouts.hStack.align(START, CENTER),
          ...defaultGapping.mediumGap,
        }}
      >
        <div>{`${c?.numberOfHoles} Holes`}</div>
        <GSDivider
          style={{
            width: "1px",
            height: "16px",
            backgroundColor: golfstatusColors.grey300,
          }}
        />
        <div>{`${c?.assignedTeamsCount ?? 0} Assigned Team${c?.assignedTeamsCount === 1 ? '' : 's'}`}</div>
      </div>
    );
  };

  const getRoundInfo = (c) => {
    let roundInfo = {
      sectionItems: [
        { type: "secondary", value: c?.course?.name },
        { type: "secondary", value: getHoles(c) },
        {
          type: "secondary",
          value: round?.tees?.[0]?.name
            ? `${round?.tees?.map?.((t) => t.name)?.join?.(", ")} Tees`
            : ``,
        },
      ],
    };
    return roundInfo;
  };

  if (round?.roundCourses) {
    RoundInfo.sections.push(
      ...round?.roundCourses?.map?.((c) => getRoundInfo(c))
    );
  }

  RoundInfo.sections.push({
    sectionItems: [
      {
        type: " no-wrap ",
        value: (
          <GSButton
            type={`pill secondary ${getStateColor(round)}`}
            title={round?.state}
          ></GSButton>
        ),
      },
    ],
  });

  const actions = {
    fit: isPhone() ? "stretch" : "",
    sections: [
      {
        sectionItems: [
          {
            type: "no-wrap full-width",
            value: <GSItemList items={priorityActions} type="horizontal mobile-vertical medium-gap" listItem={(item) => <GSButton style={{...defaultLayouts.fullWidth}} {...item}/>}/>,
          },
        ],
      },
    ],
  };

  const copy = {
    sections: [
      {
        sectionItems: [
          {
            type: "no-wrap",
            value: (
              <GSButton
                type={`light-grey`}
                buttonIcon={faClone}
                onClick={copyRound}
              ></GSButton>
            ),
          },
        ],
      },
    ],
  };

  const edit = {
    sections: [
      {
        sectionItems: [
          {
            type: "no-wrap",
            value: (
              <GSButton
                type={`light-grey`}
                buttonIcon={faPen}
                onClick={onEditClicked}
              ></GSButton>
            ),
          },
        ],
      },
    ],
  };

  let group = [{ ...RoundInfo }];

  if (!hideActions) {
    group.push({ ...actions });
  }

  if (!hideCopy) {
    group.push({ ...copy });
  }

  if (editRound) {
    group.push({ ...edit });
  }

  if (!isListItem) {
    return (
      <tournament-round-line-item>
        <GSInfoGroup listType="mobile-vertical" dataGroups={group} />
      </tournament-round-line-item>
    );
  }

  return (
    <tournament-round-line-item
      style={{ ...defaultLayouts.vStack, ...defaultLayouts.fullWidth }}
    >
      {subRoundLabel && <div className="sub-round-label">{subRoundLabel}</div>}
      <GSInfoGroup
        style={{
          ...defaultPadding.xLargePad,
          //the label sits directly on top of the round info it names.
          ...(subRoundLabel ? { paddingTop: 0 } : {}),
        }}
        listType="mobile-vertical"
        dataGroups={group}
      />
    </tournament-round-line-item>
  );
};

export default TournamentRoundLineItem;
